function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.76,13.11a7,7,0,0,1-3.912,1.28A6.563,6.563,0,0,1-1.875,7.667,7.037,7.037,0,0,1,.212,2.795,7.039,7.039,0,0,1,5.084.707,6.564,6.564,0,0,1,11.807,7.43a6.988,6.988,0,0,1-1.28,3.914l4.064,4.063-1.767,1.767ZM1.919,4.5a4.392,4.392,0,0,0-.107,6.2,4.392,4.392,0,0,0,6.2-.107,4.392,4.392,0,0,0,.107-6.2,4.22,4.22,0,0,0-3-1.229A4.527,4.527,0,0,0,1.919,4.5Z",
  transform: "translate(1.876 -0.706)",
  fill: "#b9b9b9"
});

var SvgSearchIcon = function SvgSearchIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.467,
    height: 16.467,
    viewBox: "0 0 16.467 16.467",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-icon.8eafdc8e.svg";
export { ForwardRef as ReactComponent };